import React from 'react';
import SearchBox from './SearchBox';

export interface SearchValue<T> {
  value: string;
  types: T[];
  exact?: boolean;
}
type BaseProps<T> = {
  types: T[];
  value?: SearchValue<T>;
  exact?: boolean;
  onSearch: (value: SearchValue<T>) => void;
};
type Props<T> = Omit<
React.ThHTMLAttributes<HTMLTableCellElement>, keyof BaseProps<T>> & BaseProps<T>;

const SearchableHeader = <T, >({
  types, onSearch, exact, ...props
}: Props<T>) => (
  <th {...props}>
    <SearchBox
      className="form-control"
      placeholder="Søg"
      onChange={(event) => onSearch({ value: event.target.value, types, exact })}
    />
  </th>
  );

export default SearchableHeader;
